function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "home_svg__a",
  x1: 68,
  y1: 69.4,
  x2: 154.61,
  y2: 156.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Home_ic"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80 168H56a16 16 0 01-16-16V97.4l56-56 56 56V152a16 16 0 01-16 16H80z",
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4a4d4e",
  d: "M80 116h32v52H80z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.06,
  d: "M80 114h32v2H80z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4a4d4e",
  d: "M124 36h16v41.4l-16-16V36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.51 101.39a8.49 8.49 0 01-6-2.49L96 41.4 38.56 98.84a8.49 8.49 0 01-6 2.49 8.49 8.49 0 01-6-14.49l58.13-58.13a16 16 0 0122.63 0l58.19 58.19a8.49 8.49 0 01-6 14.49z",
  fill: "#e60000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136 166H56a16 16 0 01-16-16v2a16 16 0 0016 16h80a16 16 0 0016-16v-2a16 16 0 01-16 16z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.94 91.92a8.49 8.49 0 01-14.43 5L152 95.4l-56-56-56 56-1.44 1.44a8.49 8.49 0 01-14.43-5 8.49 8.49 0 0014.43 7L40 97.4l56-56 56 56 1.51 1.51a8.49 8.49 0 0014.43-7z",
  opacity: 0.12
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 97.4l70.83 70.6H136a16 16 0 0016-16V97.4l-56-56z",
  opacity: 0.2,
  fill: "url(#home_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
}));

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgHome;